/**
 * Subtle fade + rise reveal for any element carrying `.cc-reveal`, applied
 * once per element as it scrolls into view. No-ops entirely when the
 * viewer prefers reduced motion (the CSS already shows those elements at
 * full opacity in that case, so skipping the observer is a pure optimization,
 * not a fallback the visuals depend on).
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll('.cc-reveal');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('cc-reveal--in');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cc-reveal--in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
